import setup from './moduleSetup';

export default {
    name: 'vendors',
    before: [],
    after: [],
    setup,
};
